import { render, staticRenderFns } from "./ForgotPasswordSent.vue?vue&type=template&id=141b1ab4&"
import script from "./ForgotPasswordSent.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordSent.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordSent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports